export enum ProjectEmailTemplateId {
    Verification = 'verification',
    MagicSession = 'magicSession',
    Recovery = 'recovery',
    Invitation = 'invitation',
    MfaChallenge = 'mfaChallenge',
    SessionAlert = 'sessionAlert',
    OtpSession = 'otpSession',
    OtpVerification = 'otpVerification',
    OtpRecovery = 'otpRecovery',
}
